import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import { store } from "redux/store";
import App from "app/app";
import { EventProvider } from "components/event-bus";
import ErrorBoundary from "components/error-boundary";

import "react-toastify/dist/ReactToastify.css";
import "app/index.css";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <EventProvider>
        <ErrorBoundary>
          <BrowserRouter>
            <App />
            <ToastContainer />
          </BrowserRouter>
        </ErrorBoundary>
      </EventProvider>
    </Provider>
  </React.StrictMode>
);
